export class SalesTypesMovimentacoes {
  constructor(instance) {
    this.instance = instance;
  }

  getMovimentacoes(produtoId, filter) {
    const filtredParams = filter ? { ...filter } : {};

    delete filtredParams.intervalo;
    delete filtredParams.page;

    if (filtredParams.dateStart) {
      filtredParams.dataInicio = filtredParams.dateStart;
      delete filtredParams.dateStart;
    }
    if (filtredParams.dateEnd) {
      filtredParams.dataFim = filtredParams.dateEnd;
      delete filtredParams.dateEnd;
    }

    if (filtredParams.clienteId) {
      filtredParams.cliente = filtredParams.clienteId;
      delete filtredParams.clienteId;
    }

    return this.instance.get('/v1/cad-estoque-producao-avulsa/movimentacoes', {
      params: {
        produto: produtoId,
        fazenda: 0,
        ...filtredParams,
      },
    });
  }

  exportCSV(filter) {
    const { produto: produtoId, ...otherFilters } = filter;
    const filtredParams = otherFilters ? { ...otherFilters } : {};

    if (filtredParams.dateStart) {
      filtredParams.dataInicio = filtredParams.dateStart;
      delete filtredParams.dateStart;
    }
    if (filtredParams.dateEnd) {
      filtredParams.dataFim = filtredParams.dateEnd;
      delete filtredParams.dateEnd;
    }
    if (filtredParams.clienteId) {
      filtredParams.cliente = filtredParams.clienteId;
      delete filtredParams.clienteId;
    }

    return this.instance.get(
      '/v1/cad-estoque-producao-avulsa/movimentacoes/exportar',
      {
        params: {
          produto: produtoId,
          fazenda: 0,
          ...filtredParams,
        },
        responseType: 'blob',
      },
    );
  }
}

export default SalesTypesMovimentacoes;
